import { useState } from "react";
import { ApiCall } from "../../../helper/axios";
import { setAdminAuth, clearAdminAuth } from "../../../helper/adminAuthStorage";

const LOGIN_URL = "wp-json/dahrEmaarApi/v1/adminLogin";
const VERIFY_URL = "wp-json/dahrEmaarApi/v1/adminLoginVerify";

export const useAdminAuth = () => {
  const [step, setStep] = useState("credentials"); // 'credentials' | 'otp'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [pendingToken, setPendingToken] = useState("");
  const [expiresIn, setExpiresIn] = useState(0);

  // Step 1 — username + password → sends OTP to the admin's email.
  const startLogin = async (username, password) => {
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const res = await ApiCall(
        "POST",
        LOGIN_URL,
        { username, password },
        {},
        "wordpress"
      );
      const data = res?.data;
      if (data?.success) {
        setPendingToken(data?.pending_token || "");
        setExpiresIn(Number(data?.expires_in) || 0);
        setMessage(data?.message || "A verification code has been sent to your email.");
        if (data?.twofa_required) {
          setStep("otp");
        }
        return { ok: true, twofaRequired: !!data?.twofa_required };
      }
      setError(data?.message || "Invalid username or password.");
      return { ok: false };
    } catch (e) {
      setError("Something went wrong. Please try again.");
      return { ok: false };
    } finally {
      setLoading(false);
    }
  };

  // Step 2 — pending_token + code → returns the admin session token.
  const verifyOtp = async (code) => {
    setError("");
    setLoading(true);
    try {
      const res = await ApiCall(
        "POST",
        VERIFY_URL,
        { pending_token: pendingToken, code },
        {},
        "wordpress"
      );
      const data = res?.data;
      if (data?.success && data?.token) {
        setAdminAuth(data.token, data.user, data.expires_in);
        return { ok: true, user: data.user };
      }
      setError(data?.message || "Invalid or expired code.");
      return { ok: false };
    } catch (e) {
      setError("Something went wrong. Please try again.");
      return { ok: false };
    } finally {
      setLoading(false);
    }
  };

  const backToCredentials = () => {
    setStep("credentials");
    setError("");
    setMessage("");
    setPendingToken("");
  };

  const logout = () => clearAdminAuth();

  return {
    step,
    loading,
    error,
    message,
    expiresIn,
    startLogin,
    verifyOtp,
    backToCredentials,
    logout,
  };
};
